

import api, { Notifiable } from '../api';

const controller = 'crfPrograma';

export interface IControleRfa {
  numero: string
  planilhaRfa: string
  statusPlanilhaRfaNome: string
  statusPlanilhaRfaCodigo: number
}

export interface ICrfProgramaControleRfa {
  id: string;
  numeroLinha: number;
  nomePrograma: string
  planilhaRfa: string
}

export interface ICrfPrograma extends Notifiable {
  nome: string
  controleRfa: string
}

export const getAllProjetoPlanilhaRfaAtual = () =>
  api.get<IControleRfa[]>(`${controller}/ProjetoPlanilhaRfaAtual`);

export const getAllCrfPrograma = () =>
  api.get<ICrfProgramaControleRfa[]>(`${controller}`);

export const creatCrfPrograma = (value: ICrfPrograma) =>
  api.post<ICrfPrograma>(`${controller}`, value);

export const deleteCrfPrograma = (id: string) =>
  api.delete<Notification>(`${controller}/${id}`);